var ANNOUNCEMENT_STATES = {
  ACTIVE: {
    id: 'announcement.tabs.publishedDropDown',
    value: '@announcement-state/active',
    label: 'Published'
  },
  DRAFT: {
    id: 'announcement.tabs.unpublishedDropDown',
    value: '@announcement-state/draft',
    label: 'Unpublished'
  },
  DELETED: {
    id: 'announcement.tabs.deletedDropDown',
    value: '@announcement-state/deleted',
    label: 'Deleted'
  },
  ARCHIVED: {
    id: 'announcement.tabs.archivedDropDown',
    value: '@announcement-state/archived',
    label: 'Archived'
  }
};
var ANNOUNCEMENT_TYPES = {
  GENERAL: {
    id: 'announcement.create.generalAnnouncementType',
    value: '@announcement-type/announcement-type-general',
    label: 'General announcement'
  },
  COURSE_SPECIFIC: {
    id: 'announcement.create.courseSpecificAnnouncementType',
    value: '@announcement-type/announcement-type-course',
    label: 'Course specific announcement'
  }
};
var AUDIENCE_TYPES = {
  TEACHERS: {
    id: 'announcement.tabs.teachersAudienceDropDown',
    value: '@announcement-audience/teachers',
    label: 'Teachers'
  },
  PARENTS: {
    id: 'announcement.tabs.parentsAudienceDropDown',
    value: '@announcement-audience/parents',
    label: 'Parents'
  },
  STUDENTS: {
    id: 'announcement.tabs.studentsAudienceDropDown',
    value: '@announcement-audience/students',
    label: 'Students'
  },
  PRINCIPALS: {
    id: 'announcement.tabs.principalsAudienceDropDown',
    value: '@announcement-audience/principals',
    label: 'Principals'
  },
  HODS: {
    id: 'announcement.tabs.hodsAudienceDropDown',
    value: '@announcement-audience/hods',
    label: 'Hods'
  }
};
export default {
  ANNOUNCEMENT_STATES: ANNOUNCEMENT_STATES,
  ANNOUNCEMENT_TYPES: ANNOUNCEMENT_TYPES,
  AUDIENCE_TYPES: AUDIENCE_TYPES
};